import { env } from "src/env.mjs";

const Tiles = [
  {
    path: `${env.NEXT_PUBLIC_BASE_PATH}/images/Icon-Overview-Dentsply-300px.png`,
    text: 'mobileOverview',
    key: {
      en: 'Siroforce Mobile Overview',
      de: 'Siroforce Mobile im Überblick',
      it: 'Panoramica di Siroforce Mobile',
      fr: 'Aperçu de Siroforce Mobile',
      es: 'Resumen Siroforce Mobile',
    },
  },
  {
    path: `${env.NEXT_PUBLIC_BASE_PATH}/images/Icon-Access-Dentsply-300px.png`,
    text: 'siroforceMobile',
    key: {
      en: 'Access to Siroforce Mobile',
      de: 'Zugang zu Siroforce Mobile',
      it: 'Accesso a Siroforce Mobile',
      fr: 'Accès à Siroforce Mobile',
      es: 'Acceso a Siroforce Mobile',
    },
  },
  {
    path: `${env.NEXT_PUBLIC_BASE_PATH}/images/Icon-Device-Dentsply-300px.png`,
    text: 'deviceRegistration',
    key: {
      en: 'Device Registration',
      de: 'Geräteregistrierung',
      it: 'Registrazione del dispositivo',
      fr: "Enregistrement de l'appareil",
      es: 'Registro de dispositivos',
    },
  },
  {
    path: `${env.NEXT_PUBLIC_BASE_PATH}/images/Icon-Ticketing-Dentsply-300px.png`,
    text: 'ticketing',
    key: {
      en: 'Service Request / Ticket',
      de: 'Servicefall / Ticket',
      it: 'Richiesta di assistenza / Ticket',
      fr: 'Demande de service / Ticket',
      es: 'Solicitud de servicio / Ticket',
    },
  },
  {
    path: `${env.NEXT_PUBLIC_BASE_PATH}/images/Icon-Maintenance-Dentsply-300px.png`,
    text: 'preventiveMaintenance',
    key: {
      en: 'Preventive Maintenance / Market Action',
      de: 'Präventive Wartung / Market Action',
      it: 'Manutenzione preventiva / Azione di mercato',
      fr: 'Maintenance préventive / Action sur le marché',
      es: 'Mantenimiento preventivo / Revisiones especiales',
    },
  },
  {
    path: `${env.NEXT_PUBLIC_BASE_PATH}/images/Icon-Monitoring-Dentsply-300px.png`,
    text: 'monitoring',
    key: {
      en: 'Evaluation and Reporting',
      de: 'Auswertung und Reporting',
      it: 'Valutazione e reporting',
      fr: 'Évaluation et rapports',
      es: 'Evaluación e informes',
    },
  },
  {
    path: `${env.NEXT_PUBLIC_BASE_PATH}/images/Icon-Helpcenter-Dentsply-300px.png`,
    text: 'helpcenter',
    key: {
      en: 'Helpcenter',
      de: 'Hilfezentrum',
      it: 'Centro assistenza',
      fr: "Centre d'aide",
      es: 'Centro de ayuda',
    },
  }
] as const

export default Tiles
